<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-toolbar color="primary lighten-1" flat dark>
                        <v-toolbar-title>Actions</v-toolbar-title>
                    </v-toolbar>

                    <v-container>
                        <v-btn color="primary" @click="scheduleSucceeding">
                            Schedule Success
                        </v-btn>
                        <v-btn color="primary" @click="scheduleFailing">
                            Schedule Exception
                        </v-btn>
                    </v-container>

                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-toolbar color="primary lighten-1" flat dark>
                        <v-toolbar-title>Jobs</v-toolbar-title>
                        <v-spacer/>
                        <v-btn text
                               @click="loadJobs()"
                               :disabled="isLoadingJobs">
                            <v-icon>mdi-reload</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-data-table :headers="jobsHeaders" :items="jobs || []" :loading="isLoadingJobs"/>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-toolbar color="primary lighten-1" flat dark>
                        <v-toolbar-title>Failed Jobs</v-toolbar-title>
                        <v-spacer/>
                        <v-btn text
                               @click="loadFailed()"
                               :disabled="isLoadingFailed">
                            <v-icon>mdi-reload</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-data-table :headers="failedHeaders" :items="failed || []" :loading="isLoadingFailed"/>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import config from "../config";
import axios from "axios";

export default {
    name: "JobView",
    mounted() {
        this.loadAll();

    },
    data() {
        return {
            isLoadingJobs: false,
            jobs: null,
            jobsHeaders: [
                {text: 'id', value: 'id'},
                {text: 'queue', value: 'queue'},
                {text: 'payload', value: 'payload'},
                {text: 'attempts', value: 'attempts'},
                {text: 'reserved_at', value: 'reserved_at'},
                {text: 'available_at', value: 'available_at'},
                {text: 'created_at', value: 'created_at'},
            ],

            isLoadingFailed: false,
            failed: null,
            failedHeaders: [
                {text: 'id', value: 'id'},
                {text: 'connection', value: 'connection'},
                {text: 'queue', value: 'queue'},
                {text: 'payload', value: 'payload'},
                {text: 'exception', value: 'exception'},
                {text: 'failed_at', value: 'failed_at'},
            ],
        }
    },
    methods: {
        loadAll() {
            this.loadJobs();
            this.loadFailed();
        },
        loadJobs() {
            this.isLoadingJobs = true;
            axios.get(`${config.apiUrl}/database/jobs`)
                .then(response => response.data)
                .then(jobs => this.jobs = jobs)
                .finally(() => this.isLoadingJobs = false);
        },
        loadFailed() {
            this.isLoadingFailed = true;
            axios.get(`${config.apiUrl}/database/failed_jobs`)
                .then(response => response.data)
                .then(failed => this.failed = failed)
                .finally(() => this.isLoadingFailed = false);
        },

        scheduleSucceeding() {
            axios.post(`${config.apiUrl}/schedule/success`);
        },
        scheduleFailing() {
            axios.post(`${config.apiUrl}/schedule/fail`);
        }
    }
}
</script>

<style scoped>

</style>
